import React, { useEffect, useRef } from 'react'
import { BODY_FONT } from '../lib/palette'

const DRAWER_WIDTH = 380
const TITLE_ID = 'now-map-drawer-title'

const Drawer = ({ palette, isNarrow, kicker, onRequestClose, children }) => {
    const drawerRef = useRef(null)
    const closeRef = useRef(onRequestClose)
    closeRef.current = onRequestClose

    // Move focus into the dialog on open; restore it to the triggering element on close.
    useEffect(() => {
        const opener = document.activeElement
        if (drawerRef.current) drawerRef.current.focus()
        return () => {
            if (opener && typeof opener.focus === 'function') opener.focus()
        }
    }, [])

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key === 'Escape' || e.key === 'Esc') closeRef.current()
        }
        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    }, [])

    const base = {
        position: 'fixed',
        background: palette.panelBg,
        zIndex: 20,
        boxShadow: '0 8px 40px rgba(0,0,0,0.14)',
        padding: '28px 26px',
        boxSizing: 'border-box',
        overflowY: 'auto',
        outline: 'none',
    }
    const styles = {
        overlay: { position: 'fixed', inset: 0, background: 'rgba(20,18,15,0.28)', zIndex: 10 },
        drawer: isNarrow
            ? { ...base, left: 0, right: 0, bottom: 0, top: 'auto', maxHeight: '78vh', borderRadius: '20px 20px 0 0' }
            : { ...base, top: 0, right: 0, bottom: 0, width: DRAWER_WIDTH },
        head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' },
        kicker: { fontSize: '11px', fontWeight: 600, letterSpacing: '0.1em', color: palette.sub, textTransform: 'uppercase' },
        closeBtn: { fontFamily: BODY_FONT, fontSize: '13px', background: 'none', border: 'none', color: palette.sub, cursor: 'pointer' },
    }

    return (
        <>
            <div style={styles.overlay} onClick={onRequestClose} />
            <div ref={drawerRef} style={styles.drawer} role="dialog" aria-modal="true" aria-labelledby={TITLE_ID} tabIndex={-1}>
                <div style={styles.head}>
                    <span id={TITLE_ID} style={styles.kicker}>
                        {kicker}
                    </span>
                    <button style={styles.closeBtn} onClick={onRequestClose}>
                        Close
                    </button>
                </div>
                {children}
            </div>
        </>
    )
}

export default Drawer
